import "./style.scss";
import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";

interface IContactForm {
  name: string;
  phone: string;
  email: string;
}

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<IContactForm>();

  const [formData, setFormData] = useState<IContactForm | null>(null);

  const onSubmit: SubmitHandler<IContactForm> = (data) => {
    setFormData(data);
    console.log("Готовый объект для отправки:", data);
    reset();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="contact-form">
      <div className="contact-form-title">
        <p>QUICK CONTACT ADMISSIONS</p>
      </div>
      <div className="contact-form-inputs">
        <div className="contact-form-input">
          <input placeholder="Name:" {...register("name", { required: "Name is required" })} />
          {errors.name && <p className="Error">{errors.name.message}</p>}
        </div>
        <div className="contact-form-input">
          <input
            placeholder="Phone:"
            {...register("phone", {
              required: "Phone is required",
              pattern: {
                value: /^\+?\d{10,15}$/,
                message: "Enter a valid phone number",
              },
            })}
          />
          {errors.phone && <p className="error">{errors.phone.message}</p>}
        </div>
        <div className="contact-form-input">
          <input
            placeholder="Email:"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Enter a valid email",
              },
            })}
          />
          {errors.email && <p className="error">{errors.email.message}</p>}
        </div>
      </div>
      <div className="contact-form-button">
        <button type="submit">Send</button>
      </div>
    </form>
  );
};

export default ContactForm;